module.exports = __webpack_public_path__ + "img/premium-page-header.ea455448.svg";